const MODEL_NAMES = {
    'claude-opus-5-5': 'Opus 5.5',
    'claude-sonnet-5': 'Sonnet 5',
    'claude-haiku-5': 'Haiku 5',
    'claude-haiku-4-5-20251001': 'Haiku 4.5',
    'gpt-5.5-codex': 'GPT-5.5 Codex',
};
/** Human model name for chips ("claude-opus-5-5" → "Opus 5.5"). */
export function prettyModel(m) {
    return MODEL_NAMES[m] ?? m;
}
export function formatDuration(ms) {
    if (ms == null || !Number.isFinite(ms))
        return '';
    if (ms < 1000)
        return `${Math.max(0, Math.round(ms))}ms`;
    const s = Math.round(ms / 1000);
    if (s < 60)
        return `${s}s`;
    const m = Math.floor(s / 60);
    const rs = s % 60;
    if (m < 10)
        return rs ? `${m}m ${rs}s` : `${m}m`;
    if (m < 60)
        return `${m}m`;
    const h = Math.floor(m / 60);
    const rm = m % 60;
    return rm ? `${h}h ${rm}m` : `${h}h`;
}
export function formatTokens(n) {
    if (n == null)
        return '';
    if (n < 1000)
        return String(n);
    if (n < 10_000)
        return `${(n / 1000).toFixed(1).replace(/\.0$/, '')}k`;
    if (n < 1_000_000)
        return `${Math.round(n / 1000)}k`;
    return `${(n / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
}
export function formatBytes(n) {
    if (n == null)
        return '';
    if (n < 1024)
        return `${n} B`;
    if (n < 1024 * 1024)
        return `${Math.round(n / 1024)} KB`;
    return `${(n / 1024 / 1024).toFixed(1)} MB`;
}
export function formatCost(usd) {
    if (usd == null)
        return '';
    return usd < 0.01 ? '<$0.01' : `$${usd.toFixed(2)}`;
}
export function formatClock(ts) {
    const d = new Date(ts);
    return `${String(d.getUTCHours()).padStart(2, '0')}:${String(d.getUTCMinutes()).padStart(2, '0')}`;
}
export function formatAgo(ts, now) {
    const d = Math.max(0, now - ts);
    if (d < 45_000)
        return 'just now';
    const m = Math.round(d / 60_000);
    if (m < 60)
        return `${m}m ago`;
    const h = Math.round(m / 60);
    if (h < 24)
        return `${h}h ago`;
    return `${Math.round(h / 24)}d ago`;
}
const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;
/**
 * The L0 summary row: "Worked 4m · 12 commands · 3 files +84/−12".
 * Returns parts so the component can style the diff stat separately.
 */
export function summaryParts(s, durationMs, live) {
    const lead = `${live ? 'Working' : 'Worked'}${durationMs ? ` ${formatDuration(durationMs)}` : ''}`;
    const parts = [];
    // Importance order: edits, then commands/tests, then reads/searches.
    if (s.files)
        parts.push(`edited ${plural(s.files, 'file')}`);
    else if (s.edits)
        parts.push(plural(s.edits, 'edit'));
    if (s.commands)
        parts.push(plural(s.commands, 'command'));
    if (s.subagents)
        parts.push(plural(s.subagents, 'agent'));
    if (!s.commands && !s.files && (s.reads || s.searches))
        parts.push(plural(s.reads + s.searches, 'read'));
    if (s.web)
        parts.push(plural(s.web, 'web lookup'));
    if (s.images)
        parts.push(plural(s.images, 'image'));
    if (!parts.length && s.tools)
        parts.push(plural(s.tools, 'step'));
    return { lead, parts };
}
export function summaryText(s, durationMs, live = false) {
    const { lead, parts } = summaryParts(s, durationMs, live);
    const diff = s.additions || s.deletions ? ` +${s.additions}/−${s.deletions}` : '';
    return [lead, ...parts].join(' · ') + diff;
}
//# sourceMappingURL=format.js.map